<template>
  <div class="page-wrapper">
    <static-block-component page="event" position="top"/>
    <div
        class="content-wrapper event-content max-content-wrapper"
        :class="{ 'sidebar-opened': sidebarDisplayed }"
    >
      <div
          class="left-sidebar"
          v-click-outside="() => toggleSidebarDisplay(false)"
      >
        <div
            class="title"
            @click.stop="toggleSidebarDisplay(!sidebarDisplayed)"
        >
          {{ $t('Schedule') }}
          <div class="close-sidebar">
            <single-angle/>
          </div>
        </div>
        <div class="sidebar-toggled" @click.stop>
          <event-status-router/>
          <div v-if="showInsights" class="bannerContainer">
            <div
                class="alert alert-warning alert-dismissible fade show"
                role="alert"
            >
              <div class="banner-text">
                <div v-html="$t('PACKAGE.insights')"></div>
              </div>
              <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <favorites-list
              :selectedFavorites="selectedFavorites"
              @update:selectedFavorites="onSelectedFavoritesUpdated"
              @interface="updateInterface($event, 'favoritesListInterface')"
              @allFavorites="allFavoritesRequest"
          />
        </div>
      </div>
      <div class="right-sidebar">
        <div class="options-wrapper">
          <div class="options_first-line">
            <div class="calendar-wrapper">
              <div class="flex-grow-1 position-relative">
                <date-picker
                    v-model="date_start"
                    mode="date"
                    class="date-pickers"
                    :input-props='{placeholder:"Select Date"}'
                    :masks="{input: 'YYYY-MM-DD'}"
                    readonly
                />
                <button-component
                    v-if="date_start"
                    variant="icon"
                    class="clear-date"
                    @btn-click="clearDate('date_start')"
                >
                  <x-mark-icon/>
                </button-component>
              </div>
            </div>
            <div class="search-wrapper">
              <search-field
                  @search="onSearch"
                  class="flex-grow-1 position-relative"
              />
            </div>
          </div>
          <div class="filters-wrapper w-100">
            <category-filter
                @update:category="onCategoryUpdate"
                @interface="updateInterface($event, 'categoryFilterInterface')"
            />
            <gender-filter
                @update:gender="onGenderUpdate"
                @interface="updateInterface($event, 'genderFilterInterface')"
            />
          </div>
        </div>
        <adsense-block adClient="ca-pub-9623662250069302" adSlot="8527483633"/>
        <static-block-component page="event" position="middle"/>
        <div class="grid-title">
          <span>{{ pageTitle }}</span>
          <span>{{ $t('Total') }}: {{ meta.total }}</span>
        </div>
        <div v-if="eventList.length" class="card-wrapper">
          <c-w-event-card
              v-for="event in eventList"
              :key="event.id"
              :event="event"
          />
        </div>
        <h2 v-else-if="!processing" class="mt-5 no-events">
          {{ $t('noEvents') }}
        </h2>
        <loader-component v-show="processing"/>
        <adsense-block adClient="ca-pub-9623662250069302" adSlot="8691135167"/>
        <button-component
            :disabled="processing"
            v-if="canLoadMore && !processing"
            title="Show more"
            @btn-click="showMoreHandle"
        />
      </div>
    </div>
    <static-block-component page="event" position="bottom"/>
  </div>
</template>

<script>
import StaticBlockComponent from '../../components/StaticBlockComponent';
import EventStatusRouter from '../../components/events/EventStatusRouter';
import FavoritesList from '../../components/favorites/FavoritesList';
import {ALL_EVENTS, LIVE, PAGES_NAMES, UPCOMING, VOD} from '@/pages';
import {FAVORITE_TYPES, ORDER_STATUS, STREAM_STATUS, URL_QUERIES} from '@/const';
import CategoryFilter from '../../components/base-components/CategoryFilter';
import CWEventCard from '../components/EventCards/EventCard_v2.vue';
import LoaderComponent from '../../components/LoaderComponent';
import {mapActions, mapGetters} from 'vuex';
import {
  GET_EVENTS_LIST,
  GET_FAVORITE_EVENTS,
  GET_ORDERS,
  GET_PARTICIPANTS_PROPS,
} from '@/store/actionTypes';
import ButtonComponent from '../../components/base-components/buttons/ButtonComponent';
import SingleAngle from '@/assets/img/singleAngle';
import XMarkIcon from '@/assets/img/XMarkIcon';
import GenderFilter from '@/components/base-components/Filters/GenderFilter.vue';
import AdsenseBlock from '../../components/base-components/adsense/AdsenseBlock';
import {mapState} from 'vuex';
import {mapCacheActions} from 'vuex-cache';
import SearchField from '@/components/base-components/SearchField.vue';
import {GET_BASIC_PASS_NEED} from '@/store/getterTypes';
import VisaicV3Analytics from '@/components/base-components/Analytics/VisaicV3Analytics';

const REQUEST_LIMIT = 12;
const initMeta = {
  total: 0,
  limit: REQUEST_LIMIT,
  offset: 0,
};
const initFavorite = {
  [FAVORITE_TYPES.group]: {},
  [FAVORITE_TYPES.category]: {},
  [FAVORITE_TYPES.participant]: {},
};

export default {
  name: 'EventsScreen',
  components: {
    GenderFilter,
    SearchField,
    XMarkIcon,
    SingleAngle,
    ButtonComponent,
    LoaderComponent,
    CWEventCard,
    CategoryFilter,
    FavoritesList,
    EventStatusRouter,
    StaticBlockComponent,
    AdsenseBlock,
  },
  PAGES: {
    VOD,
    LIVE,
    UPCOMING,
    ALL_EVENTS,
  },
  data() {
    return {
      requestOffset: 0,
      date_start: null,
      currentRoute: this.$route.path,
      selectedGroup: null,
      selectedCategory: null,
      selectedGender: null,
      processing: false,
      eventList: [],
      selectedFavorites: initFavorite,
      meta: initMeta,
      canLoadMore: false,
      teamFilterInterface: null,
      categoryFilterInterface: null,
      favoritesListInterface: null,
      genderFilterInterface: null,
      oneRequestPerTick: false,
      sidebarDisplayed: false,
      allFavoriteRequested: false,
      showInsights: false,
      searchQuery: '',
      abortController: null,
    };
  },
  watch: {
    $route() {
      this.currentRoute = this.$route.path;
      this.reset();
    },
    date_start() {
      this.reset();
    },
    meta(newMeta) {
      this.canLoadMore = newMeta.total > (newMeta.limit + newMeta.offset);
    },
    requestParams() {
      if (this.oneRequestPerTick) return;
      this.oneRequestPerTick = true;
      this.toggleSidebarDisplay(false);
      this.$nextTick(() => {
        this.getEvents();
        this.oneRequestPerTick = false;
      });
    },
  },
  computed: {
    ...mapState({
      authUser: (state) => state.auth.user,
      channelSettings: (state) => state.channel.settings,
    }),
    ...mapGetters({
      basicPassNeed: GET_BASIC_PASS_NEED,
    }),
    pageTitle() {
      const status = this.$t(this.pageData.pageTitle);
      const favorite = Object.values(this.selectedFavorites)
          .map((typedList) => Object.values(typedList)
              .map((item) => item.favoritable?.name))?.flat?.();

      const favoriteTitle = favorite?.[0];

      if (this.allFavoriteRequested) return `${this.$t('All favourites')} - ${status}`;
      if (favoriteTitle) return `${favoriteTitle} - ${status}`;

      return `${this.selectedGroup?.name || ''}${this.selectedGroup?.name ? ' - ' : ''}
      ${this.selectedCategory?.name || ''}${this.selectedCategory?.name ? ' - ' : ''}
      ${status}`;
    },
    pageData() {
      if (this.currentRoute === this.$options.PAGES.LIVE.path) {
        return {
          streamStatus: [STREAM_STATUS.live],
          pageTitle: PAGES_NAMES.LIVE,
          sortDirection: 'asc',
        };
      }
      if (this.currentRoute === this.$options.PAGES.UPCOMING.path) {
        return {
          streamStatus: [STREAM_STATUS.upcoming],
          pageTitle: PAGES_NAMES.UPCOMING,
          sortDirection: 'asc',
        };
      }
      if (this.currentRoute === this.$options.PAGES.VOD.path) {
        return {
          streamStatus: [STREAM_STATUS.vod],
          pageTitle: PAGES_NAMES.VOD,
          sortDirection: 'desc',
        };
      }
      return {
        streamStatus: [STREAM_STATUS.vod, STREAM_STATUS.live, STREAM_STATUS.upcoming],
        pageTitle: PAGES_NAMES.ALL_EVENTS,
        sortDirection: 'asc',
      };
    },
    requestParams() {
      let startDayTs;
      let endDayTs;
      if (this.date_start) {
        const dayObj = new Date(this.date_start);
        startDayTs = parseInt(String(dayObj / 1000));
        const endOfDay = dayObj.setHours(23, 59, 59);
        endDayTs = parseInt(String(endOfDay / 1000));
      }
      const favoriteGroups = Object.keys(this.selectedFavorites?.[FAVORITE_TYPES.group]);
      const favoriteCategory = Object.keys(this.selectedFavorites?.[FAVORITE_TYPES.category]);
      const favoriteParticipant = Object.keys(this.selectedFavorites?.[FAVORITE_TYPES.participant]);
      const params = {
        stream_status: this.pageData.streamStatus,
        limit: REQUEST_LIMIT,
        offset: this.requestOffset,
        ...(this.date_start ?
            {
              start_date: startDayTs,
              end_date: endDayTs,
            } :
            {}
        ),
        ...(favoriteParticipant.length ? {participants: favoriteParticipant} : {}),
        ...(this.pageData.sortDirection ? {sort_direction: this.pageData.sortDirection} : {}),
        ...(this.searchQuery? {search_text: this.searchQuery} : {}),
      };

      if (this.selectedGender) {
        const propId = Object.keys(this.selectedGender);
        params[`participant_properties[${propId}]`] = Object.values(this.selectedGender);
      }
      if (this.selectedGroup || favoriteGroups.length) {
        params.participant_groups = [
          ...favoriteGroups,
          ...(this.selectedGroup ? [this.selectedGroup.id] : []),
        ];
        params.recursively_participant_groups = 1;
      }
      if (this.selectedCategory || favoriteCategory.length) {
        params.categories = [
          ...favoriteCategory,
          ...(this.selectedCategory ? [this.selectedCategory.id] : []),
        ];
        params.recursively_categories = 1;
      }

      return params;
    },
  },
  methods: {
    ...mapActions({
      getEventsListRequest: GET_EVENTS_LIST,
      getAllFavoriteRequest: GET_FAVORITE_EVENTS,
      getProps: GET_PARTICIPANTS_PROPS,
    }),
    ...mapCacheActions({getOrders: GET_ORDERS}),
    reset() {
      this.requestOffset = 0;
      this.eventList = [];
      this.meta = initMeta;
    },
    showMoreHandle() {
      this.requestOffset += REQUEST_LIMIT;
    },
    onGroupUpdate(group) {
      this.allFavoriteRequested = false;
      if (group) {
        this.favoritesListInterface?.clear?.();
        this.reset();
      }
      this.selectedGroup = group;
    },
    onCategoryUpdate(category) {
      this.allFavoriteRequested = false;
      if (category) {
        this.favoritesListInterface?.clear?.();
        this.reset();
      }
      this.selectedCategory = category;
    },
    onGenderUpdate(gender) {
      this.allFavoriteRequested = false;
      if (gender) {
        this.favoritesListInterface?.clear?.();
      }
      this.reset();
      this.selectedGender = gender;
    },
    onSelectedFavoritesUpdated(favoritesArr) {
      this.allFavoriteRequested = false;
      const hasIds = Object.values(favoritesArr).some(
          (type) => Object.keys(type).length,
      );
      if (hasIds) {
        this.teamFilterInterface?.clear?.();
        this.categoryFilterInterface?.clear?.();
      }
      this.reset();
      this.selectedFavorites = favoritesArr;
    },
    allFavoritesRequest(bool) {
      this.teamFilterInterface?.clear?.();
      this.categoryFilterInterface?.clear?.();
      this.reset();
      this.toggleSidebarDisplay(false);
      this.$nextTick(() => {
        this.allFavoriteRequested = bool;
        this.getEvents();
      });
    },
    getEvents() {
      if (!this.requestParams.categories && this.$route.query[URL_QUERIES.category] ||
          !this.requestParams.participant_groups && this.$route.query[URL_QUERIES.participantGroup]
      ) return;

      this.abortController?.abort?.();
      this.processing = true;
      this.$nextTick(() => {
        this.abortController = new AbortController();

        const requestFunction = this.allFavoriteRequested ?
            this.getAllFavoriteRequest :
            this.getEventsListRequest;

        requestFunction({
          ...this.requestParams,
          tracking: [
            (p) => VisaicV3Analytics.trackRequest(p, this.searchQuery? 'search' : 'events'),
          ],
          abortSignal: this.abortController.signal,
        }).then((data) => {
          this.eventList = [
            ...this.eventList,
            ...data.data,
          ];
          this.meta = data.meta;
        }).catch(() => {
          this.eventList = [];
        }).finally(() => {
          this.processing = false;
          this.abortController = null;
        });
      });
    },
    updateInterface(methods, prop) {
      this[prop] = methods;
    },
    toggleSidebarDisplay(bool) {
      this.sidebarDisplayed = bool;
    },
    clearDate(model) {
      this[model] = null;
    },
    onSearch(query) {
      if (this.searchQuery === query) return;
      if (!query || query.length > 2 ) {
        this.reset();
        this.searchQuery = query;
      }
    },
  },
  mounted() {
    this.getEvents();
    if (this.authUser && this.basicPassNeed) {
      this.getOrders({status: ORDER_STATUS.paid}).then((data) => {
        this.showInsights = !data.length;
      });
    }
  },
  metaInfo() {
    const titleParts = [];
    this.selectedGroup?.name && titleParts.push(this.selectedGroup?.name.toUpperCase());
    this.selectedCategory?.name && titleParts.push(this.selectedCategory?.name);
    titleParts.push(this.pageData.pageTitle);
    titleParts.push(this.$route.meta.title);
    return {
      title: titleParts.join(' '),
      titleTemplate: this.channelSettings ? '%s - ' + this.channelSettings.title : '%s - Visaic',
    };
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/css/mixins";

.title {
  font-size: 2rem;
  margin-top: 1rem;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @include media-max(md) {
    font-size: 1.5rem;
  }

  .close-sidebar {
    display: none;
    @include media-max(lg) {
      display: flex;
      align-items: center;
      width: 2rem;
      height: 2rem;
      transition: all 0.2s linear;
      svg {
        transform: rotate(-90deg);
        width: 100%;
        height: 100%;
      }
    }
  }
}

.event-content {
  display: grid;
  grid-template-columns: calc(10ch + 15ch + 6rem) 1fr;
  gap: 2rem;
  padding: 3rem;
  @include media-min(xxl) {
    margin: 0 auto;
  }
  @include media-max(lg) {
    padding: 0;
    grid-template-columns: 1fr;
  }
}

.right-sidebar {
  max-width: 100vw;
  @include media-max(lg) {
    padding: 0 var(--padding-y-mobile) 3rem;
  }
  @include media-min(xxl){
    max-width: 100rem;
  }

  .no-events{
   @include media-max(md) {
      font-size: 1.5rem;
    }
  }
}

.left-sidebar {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  position: relative;

  .sidebar-toggled {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  @include media-max(lg) {
    padding: .5rem 3rem 1rem;
    background: var(--settings-body-background);
    box-shadow: var(--card-shadow);
    .sidebar-toggled {
      display: none;
    }
  }
}

.sidebar-opened {
  @include media-max(lg) {
    .sidebar-toggled {
      gap: 2rem;
      box-shadow: 0 1rem 1rem -1rem rgba(0, 0, 0, 0.5);
      padding: 2rem 3rem 3rem;
      background: var(--settings-body-background);
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 100%;
      left: 0;
      content: '';
      z-index: 5;
      width: 100%;
    }
    .close-sidebar {
      svg {
        transform: rotate(90deg);
      }
    }
  }
}

.options-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  align-items: center;
  padding-bottom: 2rem;

  .date-pickers {
    text-transform: none;
  }
  .options_first-line{
    width: 100%;
    display: grid;
    gap: 3rem;
    grid-template-columns: 1fr 1fr;
    @include media-max(md) {
      grid-template-columns: 1fr;
    }
  }
  .clear-date {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    top: 0;
    right: 0.5rem;
    width: 2rem;
    height: 100%;
    padding: 0.25rem;
  }

  .calendar-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 1px;
    padding: 0 2rem;
    background-color: var(--text-tertiary-light);
    border-radius: 0.5rem;
    border: 1px solid var(--text-tertiary-middle);
    width: 100%;
  }
}

.filters-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  @include media-max(md) {
    grid-template-columns: 1fr;
  }
}

.card-wrapper {
  display: grid;
  gap: 1.5rem;
  margin-bottom: 3rem;
  grid-template-columns: repeat( auto-fill, minmax(19rem, 1fr));
  @include media-min(max-container) {
    grid-template-columns: repeat(4, 1fr);
  }
  @include media-max(xxs) {
    grid-template-columns: 1fr;
  }
}

.grid-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;

  span {
    text-transform: capitalize;
  }
}

.banner-text {
  font-family: Roboto,sans-serif;
  font-size: 0.875rem;
  text-transform: none;
  text-align: left;
  font-weight: normal;
  font-style: normal;
}

.banner-text p {
  margin-bottom: 0.5rem;
}
</style>
